import Service from 'ember-simple-auth/services/session';
import { inject as service } from '@ember/service';

export default class SessionService extends Service {
  @service currentUser;

  async handleAuthentication() {
    super.handleAuthentication(...arguments);

    return this.currentUser.load().catch((error) => {
      this.session.invalidate();

      throw error;
    });
  }
}
